import { useMutation } from '@tanstack/react-query';
import { ResetPasswordRequest } from '@/types/request/ResetPasswordRequest';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { queryClient } from '@/main.tsx';

const useResetPassword = () => {
  const mutationFn = async (request: ResetPasswordRequest) => {
    return resetPassword(request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export default useResetPassword;

async function resetPassword(request: ResetPasswordRequest): Promise<void> {
  try {
    await BackendClient.post<BackendSuccessResponse<{ message: string }>>('/api/auth/reset-password', request);

    return;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while resetting password.');
  }
}
